<!-- 駅選択Select欄 -->
<template>
  <div class="field">
    <!-- 発駅ラベル -->
    <label>
      {{ $t("common.fromStation") }}
    </label>
    <!-- 発駅ラベル -->

    <!-- 駅選択Select -->
    <div class="select-wrap">
      <select
        v-model="selectedStationCode"
        class="form-control"
        @change="setStation(selectedStationCode)"
      >
        <!-- 乗車駅を選択してください -->
        <option :value="1">
          {{ $t("TicketStoreTicketing.defaultStation") }}
        </option>

        <!-- stationsをループ表示 -->
        <option
          v-for="(station, index) in stations"
          :key="index"
          :value="station.code"
        >
          {{ station.name }}
        </option>
      </select>
    </div>
    <!-- 駅選択Select -->
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "MbFromStationSelect",
  props: {
    stations: {
      type: Array,
      required: true,
    },
    setStation: {
      type: Function,
      required: true,
    },
  },
  setup() {
    // デフォルト 乗車駅を選択してください をセット
    const selectedStationCode = ref(1);

    return {
      selectedStationCode,
    };
  },
};
</script>

<style lang="scss" scoped>
.field {
  position: relative;
  margin: 0 0 15px 0;
}

label {
  position: absolute;
  width: 150px;
  z-index: 100;
  top: 0;
  margin-top: 15px;
  margin-left: 15px;
  font-size: 13px;
  color: #888888;
}

/* セレクトボックス */
select {
  -webkit-appearance: none;
  width: 100%;
  height: 42px;
  margin-bottom: 0;
  border: 1px solid #e0e0e0;
  border-radius: 0;
  background-color: #ffffff;
  outline: none;
  padding: 5px 10px 5px 120px;
  font-size: 16px;
  line-height: 20px;
  font-weight: bold;
  color: #000000;
}

select:focus {
  border-color: #e0e0e0;
}

.select-wrap {
  width: 100%;
  position: relative;
  display: inline-block;
  border-radius: 0;
}

.select-wrap::after {
  content: "";
  width: 6px;
  height: 6px;
  border: 0px;
  border-bottom: solid 2px #b4b3b3;
  border-right: solid 2px #b4b3b3;
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 20px;
  right: 15px;
  margin-top: -6px;
}
</style>
